import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import InventoryTimeline from '../InventoryTimeline'
import BoundaryLines from './BoundaryLines'

import useStyles from './styles'

const TimeLinesContainerWithBoundaries = ({ timelinesList, startDate, endDate, className }) => {
  const classes = useStyles()

  return (
    <div className={classnames(classes.container, className)}>
      <BoundaryLines timelineStartDate={startDate} timelineEndDate={endDate} />

      <div className={classes.timeline}>
        {timelinesList.map(timelineItem => {
          return (
            <InventoryTimeline
              key={timelineItem.id}
              name={timelineItem.name}
              label={timelineItem.label}
              conflictDates={timelineItem.conflictDates}
              startDate={startDate}
              endDate={endDate}
            />
          )
        })}
      </div>
    </div>
  )
}

TimeLinesContainerWithBoundaries.propTypes = {
  timelinesList: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired,
      conflictDates: PropTypes.arrayOf(PropTypes.string).isRequired
    })
  ).isRequired,
  startDate: PropTypes.instanceOf(Date).isRequired,
  endDate: PropTypes.instanceOf(Date).isRequired,
  className: PropTypes.string
}

export default TimeLinesContainerWithBoundaries
